// extracted by mini-css-extract-plugin
export default {"learnedSection":"LearnedObjects_learnedSection__2qqyw","title":"LearnedObjects_title__QZGK1","cardWrapper":"LearnedObjects_cardWrapper__dmfUB"};